import {
  Directive,
  ElementRef,
  Input,
  OnChanges,
  SimpleChanges,
} from '@angular/core';

@Directive({
  selector: 'modal[modalHeight]',
})
export class ModalHeightDirective implements OnChanges {
  @Input() modalHeight = '400px';
  @Input() open = false;

  constructor(private el: ElementRef<HTMLElement>) {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes['open'] && this.open === true) {
      setTimeout(() => {
        this.applyHeight();
      }, 100);
    }
  }

  private findInShadowRoots(
    root: Element | DocumentFragment,
    selector: string
  ): HTMLElement | null {
    if ('shadowRoot' in root && root.shadowRoot) {
      const found = root.shadowRoot.querySelector<HTMLElement>(selector);
      if (found) {
        return found;
      }

      const elements = Array.from(root.shadowRoot.querySelectorAll('*'));
      for (let i = 0; i < elements.length; i++) {
        const nestedResult = this.findInShadowRoots(elements[i], selector);
        if (nestedResult) {
          return nestedResult;
        }
      }
    }

    if (root instanceof Element) {
      const children = Array.from(root.querySelectorAll('*'));
      for (let i = 0; i < children.length; i++) {
        const child = children[i];
        if ('shadowRoot' in child && child.shadowRoot) {
          const found = child.shadowRoot.querySelector<HTMLElement>(selector);
          if (found) {
            return found;
          }
          const nestedResult = this.findInShadowRoots(child, selector);
          if (nestedResult) {
            return nestedResult;
          }
        }
      }
    }

    return null;
  }

  private applyHeight() {
    const modalPane = this.findInShadowRoots(
      this.el.nativeElement,
      '.modal-pane'
    );

    if (modalPane) {
      modalPane.style.height = this.modalHeight;
      modalPane.style.overflow = 'hidden';

      const contentDiv = this.findInShadowRoots(
        this.el.nativeElement,
        '.content'
      );
      if (contentDiv) {
        contentDiv.style.overflow = 'hidden';
        contentDiv.style.maxHeight = 'calc(100% - 60px)';
      }
    }
  }
}
